import React, { useCallback } from "react";
import { Link } from "react-router-dom";
import { LinkProps, useSearchParams } from "react-router-dom";
import { projectKey } from "utils/utils";

interface CustomLinkProps extends Omit<LinkProps, "to"> {
    page: string;
    view: string;
}

export default function CustomLink({ page, view, children }: CustomLinkProps) {
    const [searchParams] = useSearchParams();
    const searchQuery = useCallback(() => {
        const s = searchParams.get(projectKey);
        if (s) {
            return `/?${projectKey}=${s}`;
        }
        return "";
    }, [searchParams]);
    return (
        <Link className="no-style-link no-color-link" to={`/${page}/${view}${searchQuery()}`}>
            {children}
        </Link>
    );
}
